<template>
  <div class="seek_list_page">
    <div class="filter-container">
      <el-form
        ref="formInline"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        :label-width="labelWidth"
      >
        <el-form-item :label="$t('zlfk.theme') + ':'">
          <el-input v-model="formInline.informationSubject" :placeholder="$t('placeholder.enter')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('zlfk.vin') + ':'">
          <el-input v-model="formInline.vin" :placeholder="$t('placeholder.enter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('zlfk.status') + ':'">
          <el-select v-model="formInline.status" filterable clearable>
            <el-option :label="$t('zlfk.sp')" value="0"></el-option>
            <el-option :label="$t('zlfk.dcl')" value="1"></el-option>
            <el-option :label="$t('zlfk.clz')" value="2"></el-option>
            <el-option :label="$t('zlfk.over')" value="3"></el-option>
            <el-option :label="$t('climant.rejected')" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('zlfk.date') + ':'">
          <el-date-picker
            @change="changeDate"
            v-model="formInline.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div></div>
        <div>
          <el-button class="primary-btn" type="primary" @click="onSerach">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button
            class="primary-btn"
            icon="el-icon-refresh-right"
            plain
            @click="handleResetQuery"
          >
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="table-container">
      <el-table
        stripe
        border
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
        :max-height="maxHeight"
      >
        <el-table-column
          property="informationSubject"
          :label="$t('zlfk.theme')"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <span
              class="lineTheme"
              @click="handleDetail(scope.row)"
              >{{ scope.row.informationSubject }}</span
            >
          </template>
        </el-table-column>
        <el-table-column property="status" :label="$t('zlfk.status')">
          <template slot-scope="scope">
            <span :style="scope.row.displayStatus == 4 ? 'color:red;' : ''">{{
              getResStatus(scope.row.displayStatus)
            }}</span>
            <!-- <span v-else>{{getResStatus(scope.row.status)}}</span> -->
          </template>
        </el-table-column>

        <el-table-column property="vin" :label="$t('zlfk.vin')" align="center">
        </el-table-column>

        <el-table-column property="createTime" :label="$t('zlfk.date')" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="fenye">
      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="changePage"
      />
      <!-- <el-pagination
        layout="prev, pager, next"
        @current-change="changePage"
        :current-page.sync="page"
        :total="total"
      >
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { feedbackList } from "@/api/feedback";
import { setSession } from "@/util/localStor";
export default {
  data() {
    return {
      formInline: {
        status: "",
        informationSubject: "",
        date: "",
        vin: "",
        status: "",
      },
      nowSearch: {
        informationSubject: "",
        vin: "",
        startTime: "",
        endTime: "",
        status: "",
      },
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      maxHeight:　null,
    };
  },
  computed: {
    labelWidth () {
      const widthMap = {
        zh: '85px',
        en: '160px',
        ru: '255px',
        fa: '125px',
        vi: '180px',
        es: '270px'
      }
      return widthMap[this.$i18n.locale] || '150px'
    }
  },
  mounted() {
    this.total = this.$store.state.feedBackTotal;
    this.page = this.$store.state.feedBackPage;
    this.getList();
  },
  methods: {
    changeDate(val) {
      if (val === null) {
        this.formInline.date = "";
        this.nowSearch.startTime = "";
        this.nowSearch.endTime = "";
      }
    },
    handleCurrentChange() {},
    async getList() {
      let query = {
        data: {
          ...this.nowSearch,
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize,
        },
      };
      const res = await feedbackList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.pages * 10;
      } else {
        this.$DonMessage.warning(res.message);
      }
      this.getTableHighest(this, "maxHeight");
    },
    handleDetail(data) {
      this.$store.state.feedBackTotal = this.total;
      this.$store.state.feedBackPage = this.page;
      this.$router.push({ name: "qualityDetail", query: { vin: data.vin } });
      setSession("feedBackData", data);
    },
    getResStatus(data) {
      // ,默认为0,0待审核,1已通过,2待审核,3已取消
      let status;
      if (data == 0) status = this.$t("zlfk.sp");
      if (data == 1) status = this.$t("zlfk.dcl");
      if (data == 2) status = this.$t("zlfk.clz");
      if (data == 3) status = this.$t("zlfk.over");
      if (data == 4) status = this.$t("climant.rejected");

      return status;
    },
    changePage(val) {
      this.page = val.page;
      this.pageSize = val.limit
      this.getList();
    },
    onSerach() {
      this.page = 1;
      this.pageSize = 10;
      this.nowSearch.vin = this.formInline.vin;
      this.nowSearch.informationSubject = this.formInline.informationSubject;
      this.nowSearch.status = this.formInline.status;
      if (this.formInline.date) {
        this.nowSearch.startTime = this.formInline.date[0];
        this.nowSearch.endTime = this.formInline.date[1];
      }
      this.getList();

      // console.log(this.formInline)
    },
    handleResetQuery() {
      this.formInline = {
        status: "",
        informationSubject: "",
        date: "",
        vin: "",
        status: "",
      }
      this.$refs['formInline'].resetFields();
      this.onSerach();
    },
  },
};
</script>
